import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import BudgetCreateModalUI from './BudgetCreateModalUI.js'

class BudgetCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      successMsg: null,
      errorList: null,
      // create budget
      submitted: false,
      // budget name
      budgetName: '',
      budgetNameError: null,
      // user id
      userId: '',
      userIdList: [],
      userIdError: null,
      // assigned amount
      assignedAmt: '',
      assignedAmtError: null
    }
  }

  render() {
    return (
      <BudgetCreateModalUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        // create mode
        createMode={this.props.createMode}
        // budget name
        budgetName={this.state.budgetName}
        onBudgetNameChange={(event) => { this.setState({ budgetName: event.target.value }) }}
        budgetNameError={this.state.budgetNameError}
        setBudgetNameError={(error) => { this.setState({ budgetNameError: error }) }}
        // user id
        userId={this.state.userId}
        userIdList={this.state.userIdList}
        onUserIdChange={(event) => { this.setState({ userId: event.target.value }) }}
        userIdError={this.state.userIdError}
        // assigned amount
        assignedAmt={this.state.assignedAmt}
        onAssignedAmtChange={(event) => { this.setState({ assignedAmt: event.target.value }) }}
        assignedAmtError={this.state.assignedAmtError}
        setAssignedAmtError={(event) => { this.setState({ assignedAmtError: event.target.value }) }}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
        onCancelClick={this.onCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccountUsers(context)
    this.getMessages(context)
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context
    RestApiUtils.post(context,
      `/api/accounts/${context.session.accountId}/estimates/${this.props.match.params.orderId}/budgets`,
      this.onSubmitCallback, {
        budgetName: this.state.budgetName,
        userId: this.state.userId,
        assignedAmountF: this.state.assignedAmt
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch (error.fieldName) {
        case 'budgetName':
          this.setState({ budgetNameError: error.message })
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (this.state.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
      }, 2000)
      this.props.onCreateComplete(response.budget)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  onCancelClick = () => {
    // reset everything
    this.setState({
      successMsg: null,
      errorList: null,
      budgetNameError: null,
      submitted: false
    })
    this.props.onCancelClick()
  }

  getMessages(context) {
    let arr = [
      'c_create_budget',
      'c_create',
      'c_cancel',
      'c_budget_name',
      'c_assignee',
      'c_assigned_amount'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('bdg_crt', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }

  getAccountUsers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/users`,
      cacheKey: CacheKeys.AccountUsers(context.session.accountId),
      callback: this.getAccountUsersCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountUsersCallback = (response) => {
    if (response.accountUserList.length === 0) {
      // create page will not be reached without a customers
      // just redirect from here
      this.props.history.push('/settings/account/customers/create')
      return
    }

    let userIdList = response.accountUserList.map(user => ({
      key: user.userId,
      value: user.name
    }))
    this.setState({
      userIdList: userIdList,
      userId: userIdList[0].key
    })
  }
}

export default withRouter(BudgetCreateModalSF)
